import injaz from '../certifications/Injaz.png'
export default function CertBox({image}){
    return (
        <div className='m-5'>
        <div className=' '>
             <img src={image} width="100%"></img>
        </div>
        </div>
    )
}